module.exports = __webpack_public_path__ + "img/pjyd.0eff0b47.png";